const config = process.env.GATSBY_CONFIGURATION || "boleron";

// eslint-disable-next-line import/no-dynamic-require
const stores = require(`./${config}`);

export default stores.default;
